<script>
</script>

<style>
    #login-content-wrapper {
        margin-left: 0;
    }
</style>

<div class="app-wrapper">
    <div id="login-content-wrapper"><slot /></div>
</div>
